module.exports = __webpack_public_path__ + "11e824e173f8a03459bd7014e083b3b8.jpg";